import CodeView from 'src/components/CodeView';
import inline from 'src/examples/CSS/Display/inline';
import inlineBlock from 'src/examples/CSS/Display/inlineBlock';
import block from 'src/examples/CSS/Display/block';
import flex from 'src/examples/CSS/Display/flex';
import flexInline from 'src/examples/CSS/Display/flexInline';
import hidden from 'src/examples/CSS/Display/hidden';
import table from 'src/examples/CSS/Display/table';
import responsive from 'src/examples/CSS/Display/responsive';
import * as React from 'react';
export default {
  CodeView,
  inline,
  inlineBlock,
  block,
  flex,
  flexInline,
  hidden,
  table,
  responsive,
  React
};